<template>
<div class="vocs-category-chart">
  <div>
    <e-chart ref="ratio-chart" />
  </div>

  <div>
    <e-chart ref="top-chart" />
  </div>
</div>
</template>

<script>
import EChart from '../../../../../components/Charts/ECharts'

const COLORS = [
  '#F44336',
  '#EC407A',
  '#AB47BC',
  '#7E57C2',
  '#29B6F6',
  '#26C6DA',
  '#26A69A',
  '#66BB6A',
  '#8BC34A',
  '#D4E157',
  '#FFEE58',
  '#FFCA28',
  '#FF9800',
  '#607D8B',
  '#795548'
]

export default {
  name: 'VocsCategoryChart',
  components: {EChart},
  props: {
    siteName: {
      required: true,
      type: String
    },
    data: {
      required: true,
      type: Array
    },
    top: {
      required: true,
      type: Array
    }
  },
  methods: {
    render () {
      this.renderRatioChart()
      this.renderTopChart()
    },
    renderRatioChart () {
      let chartOpt = {
        title: {
          text: `${this.siteName} 总体平均`,
          top: 10,
          left: 'center'
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'item',
          appendToBody: true,
          formatter: param => `<div style="margin: 0px 0 0;line-height:1;"><div style="font-size:14px;color:#666;font-weight:400;line-height:1;">总体平均</div><div style="margin: 10px 0 0;line-height:1;"><div style="margin: 0px 0 0;line-height:1;">${param.marker}<span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">${param.name}:</span><span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${param.value.toFixed(2)}ppb${param.data.isHaveIntegral ? '(重积分)' : ''}</span><div style="clear:both"></div></div><div style="clear:both"></div></div><div style="clear:both"></div></div>`
        },
        series: [{
          name: '总体平均',
          type: 'pie',
          radius: '50%',
          data: this.data.map(data => ({
            name: data.groupName,
            isHaveIntegral: data.isHaveIntegral,
            value: data.value
          })),
          label: {
            formatter: param => `${param.name}:${param.percent.toFixed(2)}%`
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      }

      this.$refs['ratio-chart'].setOpt(chartOpt)
    },
    renderTopChart () {
      let {top} = this
      let chartOpt = {
        title: {
          text: `${this.siteName} VOCs平均值TOP10`,
          top: 10,
          left: 'center'
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'item',
          appendToBody: true,
          formatter: param => `<div style="margin: 0px 0 0;line-height:1;"><div style="font-size:14px;color:#666;font-weight:400;line-height:1;">VOCs平均值TOP10</div><div style="margin: 10px 0 0;line-height:1;"><div style="margin: 0px 0 0;line-height:1;">${param.marker}<span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">${param.name}:</span><span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${param.value.toFixed(2)}ppb${param.data.isHaveIntegral ? '(重积分)' : ''}</span><div style="clear:both"></div></div><div style="clear:both"></div></div><div style="clear:both"></div></div>`
        },
        xAxis: {
          type: 'category',
          data: top.map(top => top.factorName),
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            // color: 'rgba(0, 0, 0, 0)'
            show: true,
            // inside: true,
            rotate: 45
            // color: '#000'
          },
          z: 11
        },
        yAxis: {
          type: 'value',
          name: 'ppb',
          axisLine: {
            show: true
          },
          axisTick: {
            show: true
          }
        },
        grid: {
          bottom: 5,
          containLabel: true
        },
        series: [{
          name: 'VOCs平均值TOP10',
          type: 'bar',
          data: top.map((data, index) => ({
            name: data.factorName,
            value: data.value,
            isHaveIntegral: data.isHaveIntegral,
            label: {
              show: true,
              position: 'top'
              // color: '#000'
            },
            itemStyle: {
              color: COLORS[index % COLORS.length]
            }
          })),
          barMaxWidth: 30
        }]
      }

      this.$refs['top-chart'].setOpt(chartOpt)
    }
  }
}
</script>

<style lang="scss" scoped>
.vocs-category-chart {
  display: grid;
  grid-template-columns: 550px auto;
  width: 100%;
  height: 100%;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/00VOCs/04VOCs-Category-Statistical/VocsCategoryChart.vue